import { render, staticRenderFns } from "./SharedFooter.vue?vue&type=template&id=7776800d&scoped=true"
import script from "./SharedFooter.vue?vue&type=script&lang=js"
export * from "./SharedFooter.vue?vue&type=script&lang=js"
import style0 from "./SharedFooter.vue?vue&type=style&index=0&id=7776800d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7776800d",
  null
  
)

export default component.exports